import { render } from "./PrivacyAndPolicy.vue?vue&type=template&id=5e06ef61&scoped=true"
import script from "./PrivacyAndPolicy.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyAndPolicy.vue?vue&type=script&setup=true&lang=js"

import "./PrivacyAndPolicy.vue?vue&type=style&index=0&id=5e06ef61&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e06ef61"],['__file',"src/views/static-pages/PrivacyAndPolicy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e06ef61"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e06ef61', __exports__)) {
    api.reload('5e06ef61', __exports__)
  }
  
  module.hot.accept("./PrivacyAndPolicy.vue?vue&type=template&id=5e06ef61&scoped=true", () => {
    api.rerender('5e06ef61', render)
  })

}


export default __exports__